import { FC } from 'react'
import clsx from 'clsx'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import SwiperSimple from 'components/parts/swiper-simple/swiper-simple'
import IntroCard, { TypeIntroCard } from './parts/introCard/introCard'
import usePCWindow from 'hooks/usePCWindow'

import { INewslineCard } from 'constants/types/card.types'
import { ID_SWIPER, swiperProps } from './data'
import { ScreenSize } from 'constants/media-constanst'

import styles from './intro-materials.module.scss'
import stylesCommon from 'styles/main.module.scss'

interface IIntroMaterials {
  webinarsPast: INewslineCard[]
  article: INewslineCard[]
  video: INewslineCard[]
  podcast: INewslineCard[]
}
const IntroMaterials: FC<IIntroMaterials> = ({ webinarsPast, article, video, podcast }) => {
  const renderData = {
    leftPart: [webinarsPast[0], article[0], video[0], podcast[0]],
    leftPartMob: [article[0], video[0], podcast[0], webinarsPast[0]],
    rightPart: [podcast[1], article[1], video[1], webinarsPast[1]],
  }
  const isDesktop = usePCWindow(ScreenSize.big)

  if (!isDesktop) {
    return (
      <>
        <h2 className={stylesCommon.title}>Наша библиотека</h2>

        <SwiperSimple
          id={ID_SWIPER}
          swiperProps={swiperProps}
          navWrapMod={styles.swiperMod}
          disableNav
        >
          {renderData.leftPartMob.map((item, index) => {
            return (
              <IntroCard
                key={item._id}
                data={item}
                isMobile={true}
                modWrapper={styles.mobCard}
                typeCard={
                  index !== renderData.leftPartMob.length - 1
                    ? TypeIntroCard.COMMON
                    : TypeIntroCard.WEBINAR
                }
              />
            )
          })}

          {renderData.rightPart.map((item, index) => {
            return (
              <IntroCard
                key={item._id}
                data={item}
                modWrapper={styles.mobCard}
                isMobile={true}
                typeCard={
                  index === renderData.leftPart.length - 1
                    ? TypeIntroCard.WEBINAR
                    : TypeIntroCard.COMMON
                }
              />
            )
          })}
        </SwiperSimple>
      </>
    )
  }
  return (
    <WidthLimiter noBottomPadding noTopPadding>
      <h2 className={stylesCommon.title}>Наша библиотека</h2>
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          {renderData.leftPart.map((item, index) => {
            return (
              <IntroCard
                key={item._id}
                modWrapper={clsx({
                  [styles.first]: index === 0,
                  [styles.tiny]: index % 3,
                  [styles.last]: index === renderData.leftPart.length - 1,
                })}
                data={item}
                typeCard={index ? TypeIntroCard.COMMON : TypeIntroCard.WEBINAR}
              />
            )
          })}
        </div>

        <div className={styles.columnReverse}>
          {renderData.rightPart.map((item, index) => {
            return (
              <IntroCard
                key={item._id}
                modWrapper={clsx({
                  [styles.last]: index === 0,
                  [styles.tiny]: index % 3,
                  [styles.first]: index === renderData.leftPart.length - 1,
                })}
                data={item}
                typeCard={
                  index === renderData.leftPart.length - 1
                    ? TypeIntroCard.WEBINAR
                    : TypeIntroCard.COMMON
                }
              />
            )
          })}
        </div>
      </div>
    </WidthLimiter>
  )
}

export default IntroMaterials
